<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-4/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
        >
          <div class="rounded-t mb-0 px-6 py-6">
            <div class="text-center mb-3">
              <h6 class="text-blueGray-500 text-sm font-bold">
                Verify Email
              </h6>
            </div>
            <hr class="mt-6 border-b-1 border-blueGray-300" />
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  OTP Code
                </label>
                <input
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none   w-full ease-linear transition-all duration-150"
                  placeholder="OTP Code"
                  v-model="v$.auth.code.$model"
                />
                <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.auth.code.$errors" :key="index">
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>

              <div class="text-center mt-6">
                <app-button 
                  :classes="'bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150'" 
                  @click="register" 
                  :title="'Create Account'" 
                  :loading="loaders().verifyUser" 
                  :disabled="loaders().verifyUser || v$.auth.$invalid" 
                ></app-button>
              </div>
            </form>
          </div>
        </div>
       
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import AppButton from '@/components/Form/AppButton.vue';
import { required, minLength } from '@vuelidate/validators';
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AppButton
  },
  data() {
    return {
      login: {},
      errors: {},
    };
  },
  setup () {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      auth: {
        code: { required, min: minLength(6) }
      },
    }
  },
  methods: {
    ...mapActions([
      "verifyUser"
    ]),
    ...mapGetters([
      "loaders"
    ]),
    register() {
      // 
      const data = {
        code: this.auth.code,
        email: this.$route.query.email
      };
      // console.log(this.verifyUser(data))
      const self = this;
      this.verifyUser(data).then( function (res) {
        console.log(res);
        self.$router.push('/auth/login');
      }).catch( function (err) {
        self.errors = err.data ? err.data : {}
        // this.error = err;
      }).finally(() => {})
    }
  }
};
</script>
